import {
  atom,
  atomFamily,
  DefaultValue,
  selector,
  selectorFamily
} from "recoil"

import { BadgeModel, BadgeIdsSetterAction } from "./types"
import { overlayAtom } from "../../atoms/overlay"
import { searchSort } from "../../../util/searh-sort"
export const badgesAtom = atomFamily({
  key: "badgesAtom",
  default: null
})

export const badgeIdsAtom = atom({
  key: "badgeIdsAtom",
  default: []
})

// abstraction
export const badgesSelector = selectorFamily<Partial<BadgeModel>, string>({
  key: "badgesSelector",
  get:
    id =>
    ({ get }) => {
      return get(badgesAtom(id))
    },
  set:
    id =>
    ({ set }, attributes: Partial<BadgeModel> | DefaultValue) => {
      return set(badgesAtom(id), badge => ({ ...badge, ...attributes }))
    }
})

export const badgeIdsSelector = selector({
  key: "badgeIdsSelector",
  get: ({ get }) => {
    return get(badgeIdsAtom)
  },
  set: ({ set, reset, get }, action) => {
    //TODO need fix type
    //@ts-ignore
    const { name, badges, id, attributes } = action as BadgeIdsSetterAction
    if (name === "ADD") {
      // Add multiple
      let badgeArr = badges
      for (let badge of badgeArr) {
        const data =
          get(overlayAtom)?.id === badge.id
            ? { ...badge, published: true }
            : badge

        set(badgesAtom(badge.id), data)
      }

      // Add the new badgeId into BadgesIds and ensure the ids are unique
      const newBadgesIds = badgeArr.map(badge => badge.id)
      set(badgeIdsAtom, badgeIds => Array.from(new Set([...badgeIds, ...newBadgesIds])))
    }

    if (name === "UPDATE") {
      // Update only one badges
      set(badgesAtom(id), badge => ({ ...badge, ...attributes }))
    }

    if (name === "UPDATE_MULTI") {
      // Update multiple product
      for (let badge of badges) {
        set(badgesAtom(badge.id), prevBadge => ({ ...prevBadge, ...badge }))
      }
    }

    if (name === "REMOVE") {
      // remove multiple product
      let badgeArr = badges
      for (let badge of badgeArr) {
        reset(badgesAtom(badge.id))
      }
      const deletedIds = badges.map(badge => badge.id)
      set(badgeIdsAtom, prev => prev.filter(bid => !deletedIds.includes(bid)))
    }

    if (name === "RESET") {
      let badgeArr: BadgeModel[] = get(badgeIdsAtom)
      for (let badge of badgeArr) {
        reset(badgesAtom(badge.id))
      }
      set(badgeIdsAtom, [])
    }
  }
})

export const badgesFilterState = atom<{
  textField: string
  optionSort: string
}>({
  key: "badgesFilterState",
  default: {
    textField: "",
    optionSort: ""
  }
})

//This is Badges Objects List used in the LiveSell Tab in services panel
export const badgeListSelector = selector({
  key: "badgeListSelector",
  get: ({ get }) => {
    const badgeIdsList = get(badgeIdsAtom)

    const value = get(badgesFilterState)

    const sortArray = badgeIdsList
      .map(uid => get(badgesAtom(uid)))
      .sort(searchSort(value))

    if (value.textField.length > 0) {
      return sortArray.filter(badge => {
        return badge.title.toLowerCase().match(value.textField.toLowerCase())
      })
    } else {
      return sortArray
    }
  }
})

export const dummyBadges = [
  {
    id: "100001",
    title: "Walmart Icecream",
    description: "Choclate flavour with ultra rich vitamin",
    currentPrice: "$99",
    oldPrice: "$210",
    email: "helpdesk@walmart.com",
    image: "https://meetonline.io/molb/public_html/images/badges/icecream.png",
    published: false
  },
  {
    id: "100002",
    title: "Tesla Drone",
    description: "Four dimensional control with supersonic speed",
    currentPrice: "$500",
    oldPrice: "$999",
    email: "customercare@tesla.com",
    image: "https://meetonline.io/molb/public_html/images/badges/drone.jpeg",
    published: false
  },
  {
    id: "100003",
    title: "Alcohol Sanitizer",
    description: "super safe with 70% alchohol",
    currentPrice: "$50",
    oldPrice: "$85",
    email: "queries@santize.uk",
    image: "https://meetonline.io/molb/public_html/images/badges/sanitizer.png",
    published: false
  },
  {
    id: "100004",
    title: "Lagavulin scotch",
    description: "Ultra rich flavour on low cost",
    currentPrice: "$199",
    oldPrice: "$410",
    email: "help@lagavulin.com",
    image: "https://meetonline.io/molb/public_html/images/badges/scotch.jpeg",
    published: false
  },
  {
    id: "100005",
    title: "Digit Magzine",
    description: "Curious about quantum computing?",
    currentPrice: "$70",
    oldPrice: "$150",
    email: "helpdesk@digit.uk",
    image: "https://meetonline.io/molb/public_html/images/badges/magzine.png",
    published: false
  },
  {
    id: "100006",
    title: "Apple iOS 21",
    description: "Super Ultra rich UI for gamma generation",
    currentPrice: "$999",
    oldPrice: "$1350",
    email: "customer-care@apple.io",
    image: "https://meetonline.io/molb/public_html/images/badges/iphone.png",
    published: false
  }
]
